function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 14a6 6 0 0 1 12 0c0 2.142-.95 4.344-1.957 6.087a25.124 25.124 0 0 1-2.52 3.573.975.975 0 0 1-.746.34h-1.554a.975.975 0 0 1-.747-.34 25.124 25.124 0 0 1-2.519-3.573C10.95 18.345 10 16.142 10 14zm6-5a5 5 0 0 0-5 5c0 1.877.844 3.893 1.823 5.587A24.148 24.148 0 0 0 15.228 23h1.544a24.148 24.148 0 0 0 2.405-3.413C20.156 17.893 21 15.877 21 14a5 5 0 0 0-5-5zm0 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.13ef5f7267424d23d13fbc554870ecb8.svg";
export { ForwardRef as ReactComponent };